import React,{useState} from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Navbar1 from '../main/Layout/Navbar1';
import DefaultHeader from '../main/Layout/DefaultHeader';
import axios from 'axios';



function CreatePost(props) {
    const [content,setContent] = useState('');
    const [values,setValues] = useState({
        title:"",
        cate:"",
        author:"",
        error:"",
        success:false
    });
    const userId = props.match.params.userId;
    const{title,cate,author,error,success} =values;
    const handleonChange=( event, editor ) => {
        const data = editor.getData();
        setContent(data);
     };

     const handleChange =name =>event=>{
        setValues({...values,[name]:event.target.value,error:false})
     }

     const clickSubmit =(event)=>{
		event.preventDefault();
		setValues({...values,error:false});
		const body ={
				title:title,
				category:cate,
                author:author,
                content:content,  
                user:userId
		}
		axios.post('/post/create',body)
		.then(data=>{
			setValues({...values,title:"",cate:"",author:"",error:"",content:"",success:true,})//graps inital values and update to empty to clear input
		}).catch(err=>{
			setValues({...values,error:err.response.data.message,success:false})
		})

    }
    
    const showError=()=>(
        error&&(
        <div className="alert alert-danger">{error}</div>
        )
    )

    const showSuccess=()=>(
        success&&(<div className="alert alert-success">{title} created success</div>)
    )


    return (
        <React.Fragment>
            <Navbar1/>
            <DefaultHeader/>
        <div className="container ">
            {showError()}
            {showSuccess()}
                     <form >
                            <div className="form-group">                             
                                    <label htmlFor="title"><h4>Post Title</h4></label>
                                    <input onChange={handleChange('title')} value={title} type="text" className="form-control" name="title" id="title"  title="enter your first name if any."/>                           
                            </div>
                            <div className="form-group">                            
                                    <label htmlFor="category"><h4>Post Category</h4></label>
                                    <input onChange={handleChange('cate')} value={cate} list="categorys" className="form-control" name="category" id="category"  title="enter your first name if any."/> 
                                    <datalist id="categorys">
                                        <option value="Bệnh"/>
                                        <option value="Sống Khỏe"/>
                                        <option value="Mang Thai"/>
                                        <option value="Nuôi Dạy Con"/>
                                      </datalist>                             
                            </div>
                            <div className="form-group">                       
                                    <label htmlFor="author"><h4>Author</h4></label>
                                    <input onChange={handleChange('author')} value={author} type="text" className="form-control" name="author" id="author"  title="enter your last name if any."/>                               
                            </div>
                            <div className="form-group">                        
                                    <label htmlFor="content"><h4>Post Content</h4></label>
                                    <CKEditor editor={ ClassicEditor } data={content} onChange={handleonChange} />
                   
                           </div>
                            <div className="form-group">
                                <div className="col-xs-12">
                                    <br/>
                                    <button onClick={clickSubmit}  className="btn btn-lg btn-success" type="submit"><i className="check circle outline icon"></i> Publish Post</button>
                                    <button className="btn btn-lg btn-secondary" type="reset"><i className="redo icon"></i> Reset</button>
                                </div>
                            </div>
                        </form>
                </div>
        </React.Fragment>
    )
}

export default CreatePost;